import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["settings", "waitTime"];

  connect() {
    this.updateSettings();
    this.updateWaitTime();
  }

  toggle() {
    setTimeout(() => {
      this.updateSettings();
    }, 10);
  }

  toggleWaitTime() {
    setTimeout(() => {
      this.updateWaitTime();
    }, 10);
  }

  updateSettings() {
    const input = this.element.querySelector(
      'input[name="support_agent_phone[warm_transfer_enabled]"]'
    );
    const enabled = input?.value === "true";

    if (this.hasSettingsTarget) {
      this.settingsTarget.classList.toggle("hidden", !enabled);
    }
  }

  // The wait-time field only applies when human detection is on, so hide it
  // when the rep is connected immediately (opt out of human detection).
  updateWaitTime() {
    const input = this.element.querySelector(
      'input[name="support_agent_phone[opt_out_human_detection]"]'
    );
    const skipDetection = input?.value === "true";

    if (this.hasWaitTimeTarget) {
      this.waitTimeTarget.classList.toggle("hidden", skipDetection);
    }
  }
}
